import { AnswerStatus } from './answer-status';

export type Answers = Readonly<{ [key: number]: AnswerStatus }>;

export const initialAnswers = {};
